// settings.enable_canonical_indexed_collections
// If this setting is true, the url canonical will not appear in the collections that are not indexed. This behavior is determined by the value of the metafield collection.metafields.SEO.indexed and only affects collections.

function removeCanonicalLink() {
	const canonicalLink = document.querySelector('link[rel="canonical"]');

	if (canonicalLink) {
		canonicalLink.parentNode.removeChild(canonicalLink);
	}
}
removeCanonicalLink();
